import { getAlbum } from './get-album';
import { getAlbums } from './get-albums';

export const EmpeDriveService = {
    getAlbums,
    getAlbum,
};
